export default __webpack_public_path__ + "static/media/z660ma0a.38656776.mp3";